import React from "react"
import {SvgIcon, SvgIconProps} from "@mui/material"

export function OneOffIcon(props: SvgIconProps) {
	return (
		<SvgIcon {...props} viewBox="0 0 20.3924 20.3924">
			<g opacity="0.8">
				<path
					d="M16.9937 5.0981H3.39874C2.4602 5.0981 1.69937 5.85894 1.69937 6.79747V13.5949C1.69937 14.5335 2.4602 15.2943 3.39874 15.2943H16.9937C17.9322 15.2943 18.693 14.5335 18.693 13.5949V6.79747C18.693 5.85894 17.9322 5.0981 16.9937 5.0981Z"
					stroke="currentColor"
					strokeWidth="1.69937"
					strokeLinecap="round"
					strokeLinejoin="round"
					fill="none"
				/>
				<path
					d="M10.1962 11.8956C11.1347 11.8956 11.8956 11.1347 11.8956 10.1962C11.8956 9.25767 11.1347 8.49684 10.1962 8.49684C9.25768 8.49684 8.49684 9.25767 8.49684 10.1962C8.49684 11.1347 9.25768 11.8956 10.1962 11.8956Z"
					stroke="currentColor"
					strokeWidth="1.69937"
					strokeLinecap="round"
					strokeLinejoin="round"
					fill="none"
				/>
				<path
					d="M5.0981 10.1962H5.1066M15.2943 10.1962H15.3028"
					stroke="currentColor"
					strokeWidth="1.69937"
					strokeLinecap="round"
					strokeLinejoin="round"
					fill="none"
				/>
			</g>
		</SvgIcon>
	)
}
